import NextImage from '../image'
import CustomLink from '../custom-link'
import PropTypes from 'prop-types'
import classNames from "classnames"
import { buttonLinkPropTypes } from '../../../utils/types'

export function ButtonContent({ button, appearance, compact }) {
    return(
    <div className={classNames(
        // Common classes
        "inline-flex items-center justify-center gap-2 text-center font-bold transition select-none",
        "rounded-full shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-[#da3334]/35 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent",
        "disabled:opacity-60 disabled:cursor-not-allowed",
        // Full-size button
        {
            "px-6 py-3 text-sm sm:text-base": compact === false,
        },
        // Compact button
        {
            "px-4 py-2 text-sm": compact === true,
        },
        // Specific to when the button is fully dark
        {
            // Your "primary" feel: rich red
            "bg-[#da3334] text-white hover:brightness-105": appearance === "dark",
        },
        // Specific to when the button is dark outlines
        {
             "border border-[#da3334]/40 bg-white/60 text-[#da3334] hover:bg-white": appearance === "dark-outline",
        },
        // Specific to when the button is fully white
        {
            "bg-white text-primary-600 border-white": appearance === "white",
        },
        // Specific to when the button is white outlines
        {
                      "border border-white/70 bg-transparent text-white hover:bg-white/10": appearance === "white-outline",

        }
    )}>

        {button.type === 'image' &&
            button.icon &&
            (
+                <div className="overflow-hidden rounded-2xl bg-white/20 ring-1 ring-black/5">
+                    <NextImage width="160" height="124" media={button.icon} className="h-auto w-full object-cover" />

                </div>
            )}
        <span className={classNames(
            "leading-none",
            { "uppercase tracking-wide": appearance === "dark" }
        )}>
            {button.text}
        </span>
    </div>
    )
}

export default function ButtonLink({ button, appearance, compact = false }) {
    return (
    <CustomLink link={button}>
                <button
          type="button"
          className="group inline-flex"
        >
        <ButtonContent
            button={button} appearance={appearance} compact={compact} />
        </button>
    </CustomLink>)
}

ButtonLink.propTypes = {
    button: buttonLinkPropTypes,
    appearance: PropTypes.oneOf(["dark", "white-outline", "white", "dark-outline",]),
    compact: PropTypes.bool,
}